import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/base",
    name: "base",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/BaseList.vue"),
  },
  {
    path: "/production",
    name: "production",
    component: () => import("../views/Production.vue"),
  },
  {
    path: "/purchase",
    name: "purchase",
    component: () => import("../views/Purchase.vue"),
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("../views/AboutUs.vue"),
  },
  {
    path: "/BusinessLicense",
    name: "BusinessLicense",
    component: () => import("../components/BusinessLicense.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
